import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { RestClientService } from '@common/services/rest-client/rest-client.service';
import { SessionStorageService } from '@common/services/storage/session-storage.service';

@Injectable()
export class AuthGuard  {
    constructor(
        private router: Router,
        private rest: RestClientService,
        private storage: SessionStorageService
    ) {}

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        if ( !this.rest.isAuthorized() ) {
            // Guardar la URL a la que intentaba acceder el usuario
            this.storage.namespace('returnUrl').set(state.url);
            // Ir al módulo de autenticación (login)
            this.router.navigate([ '/' ], { queryParams: { returnUrl: state.url } }).then(() => { });
            return false;
        }

        return true;
    }
}
